<template>
  <v-container>
    <pre>TODO: finish dashoard</pre>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  props: {}
};
</script>
